import { useCallback } from "react";
import { useNavigate } from "react-router";

import { DropdownMenuItem } from "@certa/catalyst/components/Dropdown";
import { Gear } from "@certa/icons/components/Gear";
import { intl } from "main/src/modules/common/components/IntlCapture";
import { isCERTA2Enabled as isCERTA2EnabledConfig } from "main/src/modules/common/selectors";

import { WrapperWithIcon } from "../common";
import { useAuth } from "@certa/auth/AuthenticationProvider";

export const UserProfile = () => {
  const navigate = useNavigate();

  const authentication = useAuth();

  /** @deprecated This flag is no longer in use. */
  const isCERTA2Enabled = isCERTA2EnabledConfig();

  const userProfileId = authentication?.user?.user_profile_workflow || null;

  const goToUserProfile = useCallback(() => {
    if (isCERTA2Enabled) {
      navigate(`/process/${userProfileId}`);
    } else {
      navigate(`/workflows/instances/${userProfileId}`);
    }
  }, [navigate, isCERTA2Enabled, userProfileId]);

  return userProfileId ? (
    <DropdownMenuItem
      key="profile"
      value={intl.formatMessage({
        id: "workflowsInstances.profileText"
      })}
      onSelect={goToUserProfile}
    >
      <WrapperWithIcon icon={<Gear />}>
        {intl.formatMessage({ id: "workflowsInstances.profileText" })}
      </WrapperWithIcon>
    </DropdownMenuItem>
  ) : null;
};
